module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_4.459d6ec9.png";